export const environment = {
  production: true,
  apiUrl: 'https://cma-servicedesk-api-prd.azurewebsites.net',
  locale: 'en',
  defaultLocale: 'en',
  cmaWebUrl: 'https://cmaweb.chep.com'
};
